import { render, staticRenderFns } from "./BlogsLandingPage.vue?vue&type=template&id=3c92202e&"
import script from "./BlogsLandingPage.vue?vue&type=script&lang=ts&"
export * from "./BlogsLandingPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports